import React from 'react';
import config from '../config';


const Contact = () => (
  <div>
    <h2>Contact & Support</h2>
    <p>If you are having issues with one of our applications, or would just like to reach out</p>
    <p>Email us at: <a href={"mailto:" + config.companyEmail}>{config.companyEmail}</a></p>
  </div>
);

export default Contact;